import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import apt from './modules/apt'
import home from './modules/home'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters: {
    token (state) {
      return state.user.userInfo.token
    }
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    user,
    apt,
    home
  }
})
